import { useState } from "react"
import {
  Heading,
  useToast,
} from "@chakra-ui/react"
import { NavLayout } from "../components/NavLayout"
import useAxiosPrivate from "../hooks/useAxiosPrivate"
import { useNavigate } from "react-router-dom"
import { UserForm } from "../components/Forms/UserForm"
import { addServerErrors } from "../services/add-server-errors"

type FormData = {
  username: string
  password: string
  confirm_password: string
  first_name: string
  last_name: string
  phone: string
  email_address: string
  organization: string
  timezone: string
  role: string
  active: string
}

type Errors = {
  [key: string]: { message: string }
}

const initialFormData: FormData = {
  username: "",
  password: "",
  confirm_password: "",
  first_name: "",
  last_name: "",
  phone: "",
  email_address: "",
  organization: "",
  timezone: "",
  role: "2",
  active: "1",
}

const initialErrors: Errors = {}

export const AddUser = () => {
  const axiosPrivate = useAxiosPrivate()
  const navigate = useNavigate()
  const toast = useToast()
  const [errors, setErrors] = useState(initialErrors)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (formData: FormData) => {
    setLoading(true)
    try {
      const response = await axiosPrivate.post('/users/add', formData)

      if (!response?.data?.user?.errors) {
        toast({
          title: 'Success',
          description: 'User added successfully!',
          status: 'success',
          isClosable: true,
        })
        navigate(-1)
      } else {
        addServerErrors(response?.data?.user?.errors, setErrors)
        toast({
          title: 'Error',
          description: 'Please review any errors and resubmit',
          status: 'error',
          isClosable: true,
        })
      }
    } catch (e: any) {
      toast({
        title: 'Error',
        description: e.message,
        status: 'error',
        isClosable: true,
      })
    }
    setLoading(false)
  }

  return (
    <NavLayout
      left={
        <Heading as="h1" size="lg">Add User</Heading>
      }
    >
      <UserForm edit={false} errors={errors} handleSubmit={handleSubmit} initialFormData={initialFormData} loading={loading} />
    </NavLayout>
  )
}
